import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit,
  ChangeDetectorRef,
  AfterContentChecked
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  StorageManagerService,
  DeviceinventoryService
} from '../../shared/services/index';
import { fadeInOut } from '../../shared/helpers/animations';
import {
  ICustomer,
  IRevisionHistory,
  IServiceError
} from '../../shared/models/index';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { AccordionComponent } from '@syncfusion/ej2-angular-navigations';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AccordionItem } from '@syncfusion/ej2-navigations';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { DataScopesEnum } from '../../shared/enums/dataScopes.enum';

@Component({
    selector: 'app-submission-item-details',
    templateUrl: './submission-item-details.component.html',
    styleUrls: ['./submission-item-details.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class SubmissionItemDetailsComponent
  implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {
  userGuid: string;
  customer: ICustomer;
  itemUdi: string;
  itemIssuingAgency: string;
  revisions: IRevisionHistory[] = [];
  revisionNumber: number;
  submissionGuid: string;
  subscription: Subscription;
  visible = false;
  resolverData: any[] | IServiceError;

  target = '#modalTarget';
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '30%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  deviceMapping: any;
  mapArray = [];
  itemData: any;
  dataScope: string;
  defaultPropsArray: string[] = [];
  readOnly = true;
  udiDI: string;
  budi: string;
  agency: string;
  productSKU: string;
  itemType: string;
  modelBUDI: string;
  modelAgency: string;
  headerVar: string;
  dataScopesEnum: any;
  deviceForm: FormGroup;
  sppModel = false;
  sppDevice = false;

  accordionItemsData: any = [];
  public mapping = { header: 'header', content: 'content' };

  @ViewChild('dialog', { static: true })
  public dialog: DialogComponent;

  @ViewChild('properties') accordionObj: AccordionComponent;

  itemTemplate: string;
  eudamedId: string;
  eudamedIdIssuingAgency: string;
  eudamedDi: string;
  eudamedDiIssuingAgency: string;
  showLegacy: boolean;
  applicableRegulation: string;
  public btnClick: EmitType<object> = () => {
    this.dialog.show();
  }

  constructor (
    private activatedRoute: ActivatedRoute,
    private storage: StorageManagerService,
    private deviceInventoryService: DeviceinventoryService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private appGlobals: AppGlobals
  ) { }

  ngOnInit() {

    this.dataScopesEnum = DataScopesEnum;
    //Defaulting legacyData to false
    this.showLegacy = false;
    // Get user and customer
    this.getPrincipals();

    this.getResolverData();

    // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  private getResolverData() {
    if (this.activatedRoute.snapshot.data && this.activatedRoute.snapshot.data.itemData.length) {

      // Device mapping
      if (this.activatedRoute.snapshot.data.itemData[0]) {
        this.deviceMapping = this.activatedRoute.snapshot.data.itemData[0];
        Object.keys(this.deviceMapping).map(e => {
          this.mapArray.push({
            key: e,
            value: this.deviceMapping[e]
          });
        });
      }

      this.activatedRoute.queryParams.subscribe(params => {        
        // the sppItem param is sent with the query string from the grid. Used only as a flag for indication of an SPP Device
        const historyItem = this.storage.read('sh-item');
        this.sppDevice = params.sppItem === 'true' ? true : false;
        this.applicableRegulation = (params.applicableLegislation || historyItem?.applicableLegislation || '').toUpperCase();
        this.itemType = this.activatedRoute.snapshot.params.type;
        const modelRevision = this.activatedRoute.snapshot.params.modelrevision;
        const deviceRevision = this.activatedRoute.snapshot.params.devicerevision;        
        this.revisionNumber = this.itemType === 'model' ? modelRevision : deviceRevision;
        this.submissionGuid = params.id

        if (this.submissionGuid && this.customer.customerId) {

          this.deviceInventoryService.getSubmissionItemDetails(this.itemType, this.submissionGuid).subscribe((res: any) => {

            this.itemData = res;

            if (res && res.data && res.data.result && res.data.result.length) {
              this.itemData = res.data.result[0];

              // get values from the displayItemData vs the Response because this function process overrides
              this.udiDI = this.displayItemData('Primary DI');
              this.revisionNumber = +this.displayItemData('Revision Number');
              this.budi = this.displayItemData('Basic UDI-DI');
              this.agency = this.displayItemData('Primary DI Issuing Agency');
              this.productSKU = this.displayItemData('Product SKU');
              this.modelBUDI = this.displayItemData('BUDI-DI');
              this.modelAgency = this.displayItemData('BUDI-DI Issuing Agency');
              //Legacy
              this.eudamedId = this.itemData.eudamedID;
              this.eudamedIdIssuingAgency = this.displayItemData('Eudamed ID Issuing Agency');
              this.eudamedDi = this.displayItemData('Eudamed DI');
              this.eudamedDiIssuingAgency = this.displayItemData('Eudamed DI Issuing Agency');

              // this.sppModel is used only as a flag, not interested in the value here. The value will be used on the Identification tab component
              this.sppModel = !!this.displayItemData('System or Procedure Pack Producer SRN');

              if (this.itemData) {
                this.headerVar = this.itemType === 'model' ? 'Model' : 'Device';
                // If legacy data is present then change the header
                if (this.dataScope.toLowerCase() === 'eudamed' || this.dataScope.toLowerCase() === 'swissdamed') {
                  if (this.itemData.hasOwnProperty('eudamedID') || this.itemData.hasOwnProperty('eudamedDI')) {
                    this.headerVar = this.itemType === 'model' ? 'Legacy Model' : 'Legacy Device';
                    this.showLegacy = true;
                  }
                }
                const docId = this.itemData['id'];

                if (docId) {
                  this.deviceInventoryService.getRevisionHistory(docId, this.customer.customerId).subscribe((revData: any) => {
                    this.revisions = revData.data;
                  });
                }
              }
            } else {
              this.router.navigate(['error', { message: this.appGlobals.GENERIC_ERROR_MSG }]);
            }
          });
        }
      });
    }
  }

  displayItemData(field: string): string {
    let retVal: any;
    let prop: any;
    let propValue: string;
    let itemValuePath = [];
    let itemPropsPathSegment: any;
    let defaultPropsPathSegment: any;

    if (this.itemData && field) {
      prop = this.mapArray.find(
        p => p.key.toLowerCase() === field.toLowerCase()
      );

      if (prop) {
        propValue = prop.value;

        if (propValue) {
          // Multi path value
          if (propValue.indexOf('/') > -1) {
            if (propValue.indexOf('<dataScope>') > -1) {
              propValue = propValue.replace(
                '<dataScope>',
                this.dataScope
              );
            }

            if (propValue.indexOf('<documentType>') > -1) {
              propValue = propValue.replace(
                '<documentType>',
                this.itemType + 'Data'
              );
            }

            itemValuePath = propValue.split('/');

            if (itemValuePath && itemValuePath.length > 0) {
              // Top level item data
              itemPropsPathSegment = this.itemData;

              // Get Default settings to be able to use it if no data is for the dataScope.
              defaultPropsPathSegment = this.itemData;

              itemValuePath.forEach(path => {
                // if dataScope segment or value is undefined check if it exists in Default.
                if (itemPropsPathSegment  && Object.keys(itemPropsPathSegment).length) {
                  itemPropsPathSegment =
                    itemPropsPathSegment[path];

                  if (
                    path.toLowerCase() ===
                    this.dataScope.toLowerCase()
                  ) {
                    path = 'default';
                  }

                  if (defaultPropsPathSegment) {
                    defaultPropsPathSegment =
                      defaultPropsPathSegment[path];
                  }
                } else {
                  if (defaultPropsPathSegment) {
                    if (
                      !Array.isArray(
                        defaultPropsPathSegment
                      )
                    ) {
                      defaultPropsPathSegment =
                        defaultPropsPathSegment[path];
                    }
                  }
                }
              });
            }

            // should allow the blank space so testing it against the undefined
            if (itemPropsPathSegment !== undefined && itemPropsPathSegment !== null) {

              if (typeof itemPropsPathSegment === 'object' && !Object.keys(itemPropsPathSegment).length) {
                itemPropsPathSegment = '';
              }

              retVal = itemPropsPathSegment;
            } else {

              retVal = defaultPropsPathSegment;

              if (defaultPropsPathSegment) {
                this.defaultPropsArray.push(field);
              }
            }
          } else {
            // Single path value
            retVal = this.itemData[propValue];
          }
        }
      }
    }

    return retVal;
  }

  isDefault(field: string): string {
    return this.defaultPropsArray.includes(field) ? 'highlight-fill' : '';
  }

  private getPrincipals() {
    // Get the userGuid
    this.userGuid = this.storage.read('userGuid');

    if (!this.userGuid) {
      this.router.navigate(['error', 'User is not logged in']);
    }

    // Get the current Customer
    const customer = this.storage.read('currentCustomer');

    if (customer) {
      this.customer = typeof customer === 'object' ? customer : <ICustomer>JSON.parse(customer);

    } else {
      this.router.navigate(['/home']);
    }

    this.dataScope = this.storage.read('dataScope');
  }

  accordionCreated(event) {
    this.accordionObj.items[0].expanded = true;  // mock item number

    this.accordionObj.refresh();
  }

  ngAfterViewInit(): void {
    this.visible = false;
  }

  returnToInventory() {
    this.router.navigate(['inventory']);
  }

  // Show the Revision History (retrieved above)
  displayRevisionHistory(event) {
    this.visible = true;
    this.dialog.show();
  }

  public onOverlayClick: EmitType<object> = () => {
    this.visible = false;
    this.dialog.hide();
  }

  collapseAll() {
    this.accordionObj.items.forEach((i: AccordionItem) => {
      this.accordionObj.expandItem(false);
    });
  }

  expandAll() {
    this.accordionObj.items.forEach((i: AccordionItem) => {
      this.accordionObj.expandItem(true);
    });
  }

  revisionHistoryClose(event) {
    this.visible = false;
    this.dialog.hide();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  showModelClinicalInvestigationSection(): boolean {
    if (this.sppModel) {
      return false;
    }

    const currentDataScope = (this.dataScope || '').toLowerCase();

    if (currentDataScope === DataScopesEnum.EUDAMED.toLowerCase()) {
      return true;
    }

    if (currentDataScope === DataScopesEnum.SWISSDAMED.toLowerCase()) {
      return ['MDD', 'AIMDD', 'IVDD', 'MDD-AIMDD'].includes(this.getModelApplicableRegulation());
    }

    return false;
  }

  showDevicePackagingSection(): boolean {
    return !this.isSwissdamedLegacyDeviceRegulation() && !this.isSwissdamedIvddDeviceRegulation();
  }

  getModelClinicalInvestigationHeader(): string {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase()
      ? ' Certificate Links '
      : ' Clinical Investigation and Certificate Links ';
  }

  private getModelApplicableRegulation(): string {
    const modelData = this.itemData?.modelData;
    const currentDataScope = (this.dataScope || '').toLowerCase();
    const scopedModelData = currentDataScope ? modelData?.[currentDataScope] : null;

    if (scopedModelData?.applicableRegulation) {
      return scopedModelData.applicableRegulation.toUpperCase();
    }

    if (modelData?.default?.applicableRegulation) {
      return modelData.default.applicableRegulation.toUpperCase();
    }

    return '';
  }

  private isSwissdamedLegacyDeviceRegulation(): boolean {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase() &&
      ['MDD', 'AIMDD', 'MDD-AIMDD'].includes((this.applicableRegulation || '').toUpperCase());
  }

  private isSwissdamedIvddDeviceRegulation(): boolean {
    return (this.dataScope || '').toLowerCase() === DataScopesEnum.SWISSDAMED.toLowerCase() &&
      (this.applicableRegulation || '').toUpperCase() === 'IVDD';
  }
}
